import { isMembershipExperience } from './isMembershipExperience';

/** Agent / agency / enterprise screens that use the new dash chrome instead of sidebar + split top bar. */
export function isAdashChromeUser(user) {
    if (!user) return false;
    if (isMembershipExperience(user)) return false;
    const role = String(user.role || '').toLowerCase();
    return role === 'agency'
        || role === 'agency_agent'
        || role === 'independent_agent'
        || role === 'agent'
        || role === 'enterprise'
        || role === 'partner_enterprise';
}

export const OPEN_CONCIERGE_INBOX_EVENT = 'ipm:open-concierge-inbox';
/** Floating chrome: bar sits at inset; demo bar starts just below it. */
export const ADASH_BAR_HEIGHT = 70;
export const ADASH_RAIL_OPEN = 236;
export const ADASH_RAIL_MINI = 80;
export const ADASH_RAIL_INSET = 14;
export const ADASH_RAIL_KEY = 'ipm.adashRail';
export const ADASH_RAIL_OPEN_EVENT = 'ipm:adash-rail-open';

export function readAdashRailMode() {
    try {
        const v = localStorage.getItem(ADASH_RAIL_KEY);
        if (v === 'mini' || v === 'open') return v;
    } catch { /* ignore */ }
    return 'open';
}

export function applyAdashRailMode(mode) {
    const next = mode === 'mini' ? 'mini' : 'open';
    const w = next === 'mini' ? ADASH_RAIL_MINI : ADASH_RAIL_OPEN;
    if (typeof document !== 'undefined') {
        document.documentElement.dataset.adashRail = next;
        document.documentElement.style.setProperty('--adash-rail-w', `${w}px`);
        document.documentElement.style.setProperty('--adash-inset', `${ADASH_RAIL_INSET}px`);
    }
    try { localStorage.setItem(ADASH_RAIL_KEY, next); } catch { /* ignore */ }
    return next;
}

export const ADASH_NAV_ICONS = {
    dashboard: 'ph ph-house',
    crm: 'ph ph-address-book',
    referrals: 'ph ph-share-network',
    listings: 'ph ph-squares-four',
    marketing: 'ph ph-megaphone',
    revenue: 'ph ph-chart-line-up',
    agents: 'ph ph-users',
    agencies: 'ph ph-buildings',
    franchises: 'ph ph-buildings',
    invites: 'ph ph-paper-plane-tilt',
    'network-dashboard': 'ph ph-house',
    performance: 'ph ph-chart-bar',
    finance: 'ph ph-coins',
    'branch-planner': 'ph ph-target',
    rentals: 'ph ph-key',
    'compliance-rcr': 'ph ph-shield-check',
    'my-reports': 'ph ph-file-text',
    calendar: 'ph ph-calendar',
    vault: 'ph ph-lock',
    portfolio: 'ph ph-folder',
    settings: 'ph ph-gear',
    academy: 'ph ph-graduation-cap',
};

export const ADASH_NAV_LABELS = {
    dashboard: 'Home',
    crm: 'CRM',
    referrals: 'Referrals',
    listings: 'Listings',
    marketing: 'Marketing',
    revenue: 'Sales',
    agents: 'Agents',
    agencies: 'Offices',
    franchises: 'Franchises',
    invites: 'Invites',
    'network-dashboard': 'Home',
    performance: 'Performance',
    finance: 'Finance',
    'branch-planner': 'Goals',
    rentals: 'Rentals',
    'compliance-rcr': 'FICA',
    'my-reports': 'Studio',
    calendar: 'Emails + Calendar',
    vault: 'Vault',
    settings: 'Settings',
    portfolio: 'Portfolio',
    academy: 'IPM Academy',
};
